import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/i18n";  // initialise i18next (English + Arabic + RTL flip)
import App from "@/App";
import { installRuntimeSafety } from "@/lib/runtimeSafety";
import GlobalErrorBoundary from "@/components/GlobalErrorBoundary";

// Suppress benign network rejection overlays (404/500/network noise) and
// keep the dev-server error overlay from blocking the entire app.
installRuntimeSafety();

// Filter a single, well-known Recharts dev-only warning: in React StrictMode
// the double-render briefly reports width(-1)/height(-1) before
// ResponsiveContainer's ResizeObserver fires. The chart renders correctly;
// the warning is cosmetic. We silence ONLY this exact message so any real
// chart sizing bug still surfaces.
if (process.env.NODE_ENV !== "production") {
  const origWarn = console.warn;
  console.warn = (...args) => {
    const first = args[0];
    if (typeof first === "string" && first.includes("chart should be greater than 0")) return;
    origWarn(...args);
  };
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GlobalErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </GlobalErrorBoundary>
  </React.StrictMode>,
);
